module.exports = __webpack_public_path__ + "img/Treesdotcom-horizontal-green.9a393b40.png";